var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharePannelTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#419FD9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_linear_134_2376)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7421 14.6693C11.1042 12.7289 14.0129 11.4497 15.4683 10.8316C19.6237 9.06688 20.4872 8.76033 21.05 8.7501C21.1738 8.74798 21.4505 8.7793 21.6298 8.92783C21.7812 9.05324 21.8228 9.22266 21.8428 9.34157C21.8627 9.46047 21.8875 9.73135 21.8678 9.943C21.6426 12.3588 20.6682 18.2212 20.1725 20.9269C19.9628 22.0717 19.5498 22.4556 19.1499 22.4932C18.281 22.5748 17.6212 21.9069 16.7795 21.3436C15.4626 20.4622 14.7186 19.9135 13.4403 19.0534C11.9629 18.0594 12.9206 17.513 13.7626 16.6202C13.9829 16.3865 17.8115 12.831 17.8856 12.5084C17.8948 12.4681 17.9034 12.3177 17.8159 12.2383C17.7284 12.1589 17.5993 12.1861 17.5061 12.2077C17.374 12.2383 15.2702 13.6581 11.1946 16.467C10.5974 16.8857 10.0565 17.0897 9.57188 17.079C9.03762 17.0672 8.00991 16.7706 7.24592 16.517C6.30885 16.206 5.56408 16.0416 5.62894 15.5134C5.66272 15.2383 6.03377 14.9569 6.7421 14.6693Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_2376",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 29.7774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePannelTelegramIcon);
export default __webpack_public_path__ + "static/media/share-pannel-telegram-icon.9cb524a75f7ed4cc1ce51b90b5013148.svg";
export { ForwardRef as ReactComponent };